import { lazy } from 'react'

import type { RouteObject } from 'react-router'

const ListagemEmpreendimentosPage = lazy(() =>
  import('@/features/espelho-de-vendas/chile/pages/listagem-empreendimentos').then((module) => ({
    default: module.EspelhoDeVendasPage,
  })),
)

export const chileEspelhoDeVendasRoutes: RouteObject[] = [
  {
    path: 'es-CL/espelho-de-vendas',
    children: [
      {
        index: true,
        element: <ListagemEmpreendimentosPage />,
      },
    ],
  },
]
